/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Components_Performancetable_Days1Inputs */

const id_components_performancetable_days1 = /** @type {(inputs: Components_Performancetable_Days1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("id", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`hari`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`hari`);
	return /** @type {LocalizedString} */ ("components.performanceTable.days");
};

const ms_components_performancetable_days1 = /** @type {(inputs: Components_Performancetable_Days1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ms", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`hari`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`hari`);
	return /** @type {LocalizedString} */ ("components.performanceTable.days");
};

const da_components_performancetable_days1 = /** @type {(inputs: Components_Performancetable_Days1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("da", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`dag`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`dage`);
	return /** @type {LocalizedString} */ ("components.performanceTable.days");
};

const de_components_performancetable_days1 = /** @type {(inputs: Components_Performancetable_Days1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("de", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Tag`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Tage`);
	return /** @type {LocalizedString} */ ("components.performanceTable.days");
};

const en_us2_components_performancetable_days1 = /** @type {(inputs: Components_Performancetable_Days1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en-US", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`day`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`days`);
	return /** @type {LocalizedString} */ ("components.performanceTable.days");
};

const es_es2_components_performancetable_days1 = /** @type {(inputs: Components_Performancetable_Days1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es-ES", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`día`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`días`);
	return /** @type {LocalizedString} */ ("components.performanceTable.days");
};

const es_mx2_components_performancetable_days1 = /** @type {(inputs: Components_Performancetable_Days1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es-MX", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`día`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`días`);
	return /** @type {LocalizedString} */ ("components.performanceTable.days");
};

const fil_components_performancetable_days1 = /** @type {(inputs: Components_Performancetable_Days1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fil", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`araw`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`araw`);
	return /** @type {LocalizedString} */ ("components.performanceTable.days");
};

const fr_components_performancetable_days1 = /** @type {(inputs: Components_Performancetable_Days1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fr", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`jour`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`jours`);
	return /** @type {LocalizedString} */ ("components.performanceTable.days");
};

const it_components_performancetable_days1 = /** @type {(inputs: Components_Performancetable_Days1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("it", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`giorno`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`giorni`);
	return /** @type {LocalizedString} */ ("components.performanceTable.days");
};

const hu_components_performancetable_days1 = /** @type {(inputs: Components_Performancetable_Days1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("hu", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`nap`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`nap`);
	return /** @type {LocalizedString} */ ("components.performanceTable.days");
};

const nl_components_performancetable_days1 = /** @type {(inputs: Components_Performancetable_Days1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`dag`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`dagen`);
	return /** @type {LocalizedString} */ ("components.performanceTable.days");
};

const no_components_performancetable_days1 = /** @type {(inputs: Components_Performancetable_Days1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("no", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`dag`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`dager`);
	return /** @type {LocalizedString} */ ("components.performanceTable.days");
};

const pl_components_performancetable_days1 = /** @type {(inputs: Components_Performancetable_Days1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`dzień`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`dni`);
	return /** @type {LocalizedString} */ ("components.performanceTable.days");
};

const pt_br2_components_performancetable_days1 = /** @type {(inputs: Components_Performancetable_Days1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pt-BR", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`dia`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`dias`);
	return /** @type {LocalizedString} */ ("components.performanceTable.days");
};

const pt_components_performancetable_days1 = /** @type {(inputs: Components_Performancetable_Days1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pt", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`dia`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`dias`);
	return /** @type {LocalizedString} */ ("components.performanceTable.days");
};

const ro_components_performancetable_days1 = /** @type {(inputs: Components_Performancetable_Days1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ro", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`zi`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`zile`);
	return /** @type {LocalizedString} */ ("components.performanceTable.days");
};

const fi_components_performancetable_days1 = /** @type {(inputs: Components_Performancetable_Days1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fi", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`päivä`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`päivää`);
	return /** @type {LocalizedString} */ ("components.performanceTable.days");
};

const sv_components_performancetable_days1 = /** @type {(inputs: Components_Performancetable_Days1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("sv", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`dag`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`dagar`);
	return /** @type {LocalizedString} */ ("components.performanceTable.days");
};

const vi_components_performancetable_days1 = /** @type {(inputs: Components_Performancetable_Days1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("vi", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`ngày`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`ngày`);
	return /** @type {LocalizedString} */ ("components.performanceTable.days");
};

const tr_components_performancetable_days1 = /** @type {(inputs: Components_Performancetable_Days1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("tr", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`gün`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`gün`);
	return /** @type {LocalizedString} */ ("components.performanceTable.days");
};

const cs_components_performancetable_days1 = /** @type {(inputs: Components_Performancetable_Days1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("cs", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`den`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`dní`);
	return /** @type {LocalizedString} */ ("components.performanceTable.days");
};

const bg_components_performancetable_days1 = /** @type {(inputs: Components_Performancetable_Days1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("bg", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`ден`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`дни`);
	return /** @type {LocalizedString} */ ("components.performanceTable.days");
};

const ru_components_performancetable_days1 = /** @type {(inputs: Components_Performancetable_Days1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ru", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`день`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`дней`);
	return /** @type {LocalizedString} */ ("components.performanceTable.days");
};

const uk_components_performancetable_days1 = /** @type {(inputs: Components_Performancetable_Days1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("uk", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`день`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`днів`);
	return /** @type {LocalizedString} */ ("components.performanceTable.days");
};

const ar_components_performancetable_days1 = /** @type {(inputs: Components_Performancetable_Days1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ar", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`يوم`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`أيام`);
	return /** @type {LocalizedString} */ ("components.performanceTable.days");
};

const hi_components_performancetable_days1 = /** @type {(inputs: Components_Performancetable_Days1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("hi", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`दिन`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`दिन`);
	return /** @type {LocalizedString} */ ("components.performanceTable.days");
};

const th_components_performancetable_days1 = /** @type {(inputs: Components_Performancetable_Days1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("th", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`วัน`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`วัน`);
	return /** @type {LocalizedString} */ ("components.performanceTable.days");
};

const ja_components_performancetable_days1 = /** @type {(inputs: Components_Performancetable_Days1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ja", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`日`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`日`);
	return /** @type {LocalizedString} */ ("components.performanceTable.days");
};

const zh_cn2_components_performancetable_days1 = /** @type {(inputs: Components_Performancetable_Days1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("zh-CN", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`天`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`天`);
	return /** @type {LocalizedString} */ ("components.performanceTable.days");
};

const zh_hant1_components_performancetable_days1 = /** @type {(inputs: Components_Performancetable_Days1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("zh-Hant", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`天`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`天`);
	return /** @type {LocalizedString} */ ("components.performanceTable.days");
};

const ko_components_performancetable_days1 = /** @type {(inputs: Components_Performancetable_Days1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ko", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`일`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`일`);
	return /** @type {LocalizedString} */ ("components.performanceTable.days");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "day" |
* | "other" | "days" |
*
* @param {Components_Performancetable_Days1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_performancetable_days1 = /** @type {((inputs: Components_Performancetable_Days1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Performancetable_Days1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_performancetable_days1(inputs)
	if (locale === "ms") return ms_components_performancetable_days1(inputs)
	if (locale === "da") return da_components_performancetable_days1(inputs)
	if (locale === "de") return de_components_performancetable_days1(inputs)
	if (locale === "en-US") return en_us2_components_performancetable_days1(inputs)
	if (locale === "es-ES") return es_es2_components_performancetable_days1(inputs)
	if (locale === "es-MX") return es_mx2_components_performancetable_days1(inputs)
	if (locale === "fil") return fil_components_performancetable_days1(inputs)
	if (locale === "fr") return fr_components_performancetable_days1(inputs)
	if (locale === "it") return it_components_performancetable_days1(inputs)
	if (locale === "hu") return hu_components_performancetable_days1(inputs)
	if (locale === "nl") return nl_components_performancetable_days1(inputs)
	if (locale === "no") return no_components_performancetable_days1(inputs)
	if (locale === "pl") return pl_components_performancetable_days1(inputs)
	if (locale === "pt-BR") return pt_br2_components_performancetable_days1(inputs)
	if (locale === "pt") return pt_components_performancetable_days1(inputs)
	if (locale === "ro") return ro_components_performancetable_days1(inputs)
	if (locale === "fi") return fi_components_performancetable_days1(inputs)
	if (locale === "sv") return sv_components_performancetable_days1(inputs)
	if (locale === "vi") return vi_components_performancetable_days1(inputs)
	if (locale === "tr") return tr_components_performancetable_days1(inputs)
	if (locale === "cs") return cs_components_performancetable_days1(inputs)
	if (locale === "bg") return bg_components_performancetable_days1(inputs)
	if (locale === "ru") return ru_components_performancetable_days1(inputs)
	if (locale === "uk") return uk_components_performancetable_days1(inputs)
	if (locale === "ar") return ar_components_performancetable_days1(inputs)
	if (locale === "hi") return hi_components_performancetable_days1(inputs)
	if (locale === "th") return th_components_performancetable_days1(inputs)
	if (locale === "ja") return ja_components_performancetable_days1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_performancetable_days1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_performancetable_days1(inputs)
	return ko_components_performancetable_days1(inputs)
});
export { components_performancetable_days1 as "components.performanceTable.days" }